// React
import React, { Fragment, useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

// UI and Styling
import { Box, Button, ButtonGroup, Grid } from "@material-ui/core";
import styles from "./MigrationPage.module.scss";

// Actions
import { MassCreateTargetedLinks } from "../../state/actions/CampaignActions";

// Components
import AlertDialog from "../../components/alert-dialog/AlertDialog";
import HeaderBlock from "../../components/header-block/HeaderBlock";
import PageContainer from "../../components/page-container/PageContainer";
import { LoadingComponent } from "../../components/loading2/circleLoader";

// Segments
import MigrationUploadSegment from "../../segments/content-upload-segments/MigrationUploadSegment";
import MassContentUploadSegment from "../../segments/content-upload-segments/MigrationContentUploadSegment";
import { UUID } from "../../helpers/uuid";

// Other
import { LinkMigrationExpectedColumns } from "../../state/constants/TemplateColumns";

// Moment
var moment = require("moment");
moment().format();

const LinkMigrationPage = (props) => {
  const [genericContentData, setGenericContentData] = useState({
    prefile: [
      {
        type: "file",
        value: null,
        required: true,
        errorMessage: "",
        label: "File"
      }
    ],
    file: []
  });
  const [isUploading, setIsUploading] = useState(false);
  const [csvData, setCsvData] = useState({});
  const [dataChanged, setDataChanged] = useState(false);
  const [submitEnabled, setSubmitEnabled] = useState(false);
  const [targetsEdited, setTargetsEdited] = useState(false);
  const [cancelAlertShowing, setCancelAlertShowing] = useState(false);
  const [formEdited, setFormEdited] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [csvInvalid, setCSVInvalid] = useState(false);

  const targetIds = useSelector(
    (state) => state.ResourceImageUploaderReducer.targetIds
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (targetsEdited) {
      setSubmitEnabled(true);
    }
  }, [targetsEdited]);

  useEffect(() => {
    if (dataChanged) {
      setDataChanged(false);
    }
  }, [dataChanged]);

  useEffect(() => {
    let localTargets = [];
    setCsvData(localTargets);
  }, [targetIds]);

  const handleSubmit = async () => {
    setIsUploading(true);
    if (!submitEnabled) {
      return;
    }

    setSubmitEnabled(false);

    const data = createRequestBody();

    dispatch(
      MassCreateTargetedLinks(data, (res) => {
        if (res) {
          props.history.push("/post-migration");
        }
      })
    );
  };

  // Generate the target groups for the Campaign if needed
  function getTargetGroups(row) {
    var targetGroups = [];
    var targetGroupNames = row.TargetGroupNames.split("|");
    if (
      row.hasOwnProperty("ActivityId") &&
      row.ActivityId !== null &&
      row.ActivityId !== "" &&
      row.ActivityId.length > 0
    ) {
      var activityIds = row.ActivityId.split("|");
      targetGroups.push({
        ModelType: "Activity",
        Description: "",
        CreatedBy: "Mass Migration",
        Name: targetGroupNames[targetGroups.length],
        TargetGroupRules: [
          {
            Name: "Activity_Id",
            Operator: "eq",
            Values: activityIds
          },
          {
            Name: "Activity_Site",
            Operator: "eq",
            Values: [row.Territory]
          }
        ]
      });
    }
    if (
      row.hasOwnProperty("CustomerId") &&
      row.CustomerId !== null &&
      row.CustomerId !== "" &&
      row.CustomerId.length > 0
    ) {
      var customerIds = row.CustomerId.split("|");
      targetGroups.push({
        ModelType: "Customer",
        Description: row.Description,
        CreatedBy: "Mass Migration",
        Name: targetGroupNames[targetGroups.length],
        TargetGroupRules: [
          {
            Name: "Customer_Number",
            Operator: "eq",
            Values: customerIds
          },
          {
            Name: "Customer_Site",
            Operator: "eq",
            Values: [row.Territory]
          }
        ]
      });
    }
    if (
      row.hasOwnProperty("PromotionId") &&
      row.PromotionId !== null &&
      row.PromotionId !== "" &&
      row.PromotionId.length > 0
    ) {
      var promotionIds = row.PromotionId.split("|");
      targetGroups.push({
        ModelType: "Promotion",
        Description: "",
        CreatedBy: "Mass Migration",
        Name: targetGroupNames[targetGroups.length],
        TargetGroupRules: [
          {
            Name: "Promotion_Id",
            Operator: "eq",
            Values: promotionIds
          },
          {
            Name: "Promotion_Site",
            Operator: "eq",
            Values: [row.Territory]
          }
        ]
      });
    }
    if (
      row.hasOwnProperty("MaterialId") &&
      row.MaterialId !== null &&
      row.MaterialId !== "" &&
      row.MaterialId.length > 0
    ) {
      var materialIds = row.MaterialId.split("|");
      targetGroups.push({
        ModelType: "Material",
        Description: "",
        CreatedBy: "Mass Migration",
        Name: targetGroupNames[targetGroups.length],
        TargetGroupRules: [
          {
            Name: "Material_Number",
            Operator: "eq",
            Values: materialIds
          },
          {
            Name: "Material_Site",
            Operator: "eq",
            Values: [row.Territory]
          }
        ]
      });
    }
    return targetGroups;
  }

  function getCampaign(row) {
    let Counters = row.TargetGroupIds.split("|");
    return {
      Name: row.CampaignTitle,
      Description: row.Description,
      Territory: row.Territory,
      StartDate: moment(row.StartDate, "DD/MM/YYYY").toISOString(),
      EndDate: moment(row.EndDate, "DD/MM/YYYY").toISOString(),
      ContractExpiryDate: moment(
        row.ContractExpiryDate,
        "DD/MM/YYYY"
      ).toISOString(),
      Targets: {
        TargetContentIds: [],
        TargetGroups:
          Counters[0] !== ""
            ? Counters.map(function (item) {
              return {
                Counter: item,
                IsExcluding: false
              };
            })
            : []
      }
    };
  }

  function getContent(row) {
    return {
      FileName: row.Link_URL,
      ContentPath: "",
      CategoryId: row.LinkCategory,
      Territory: row.Territory,
      Title: row.LinkTitle,
      ContractExpiryDate: moment(
        row.ContractExpiryDate,
        "DD/MM/YYYY"
      ).toISOString(),
      Description: row.LinkDescription,
      Languages: row.LinkLanguage,
      RetentionPolicyId: row.LinkRetentionPolicy,
      Keywords: row.LinkKeywords.split("|"),
      StartDate: moment(
        row.LinkEffectiveStartDate,
        "DD/MM/YYYY"
      ).toISOString(),
      EndDate: moment(row.LinkEffectiveEndDate, "DD/MM/YYYY").toISOString(),
      IsInternal: row.IsInternal,
      IsActive: true
    };
  }

  const createRequestBody = () => {
    let toReturn = [];
    csvData.forEach((row) => {
      const requestBody = {};
      requestBody["Content"] = getContent(row);
      requestBody["TargetGroups"] = getTargetGroups(row);
      requestBody["Campaign"] = getCampaign(row);
      toReturn.push(requestBody);
    });
    return toReturn;
  };

  // This refers to the cancel button on the edit or create form
  const handleCancelEditButtonClicked = () => {
    setIsEditing(false);
    props.history.push(`/content-migration`);
  };

  const cancelAlertDialog = () => {
    const title = "Are you sure you want to go back?";
    return (
      <AlertDialog
        title={title}
        description={"Any changes made will be lost."}
        options={[
          {
            label: "Cancel",
            action: () => setCancelAlertShowing(false)
          },
          {
            label: "Confirm",
            action: () => {
              props.history.replace(`/image-uploader`);
              setIsEditing(false);
              setCancelAlertShowing(false);
            }
          }
        ]}
        isOpen={cancelAlertShowing}
      />
    );
  };

  const renderSubmitAndCancelButtons = () => {
    return [
      <Button
        key={UUID()}
        variant="outlined"
        onClick={() => handleSubmit()}
        disabled={!submitEnabled || csvInvalid}
      >
        Submit
      </Button>,
      <Button
        key={UUID()}
        variant="outlined"
        onClick={() => handleCancelEditButtonClicked()}
      >
        Cancel
      </Button>
    ];
  };

  return (
    <Box>
      <Fragment>
        {isUploading ? (
          <>
            <HeaderBlock
              title={"Please Wait: Targeted Links, Campaigns and Target Groups are uploading"}
            />
            <PageContainer>
              <LoadingComponent></LoadingComponent>
            </PageContainer>
          </>
        ) : (
            <>
              <HeaderBlock
                title={"Targeted Link Mass Upload"}
                right={
                  renderSubmitAndCancelButtons() ? (
                    <Grid
                      container
                      spacing={2}
                      alignItems="center"
                      justify="flex-end"
                    >
                      <Grid item>
                        <ButtonGroup>
                          {renderSubmitAndCancelButtons()}
                        </ButtonGroup>
                      </Grid>
                    </Grid>
                  ) : null
                }
              />

              <PageContainer>
                <div className={styles.contentGrid}>
                  <Grid container spacing={3}>
                    <Grid
                      key={"migrationUploadSegment"}
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                    >
                      <MigrationUploadSegment
                        csvData={csvData}
                        setCsvData={setCsvData}
                        setDataChanged={setDataChanged}
                        title="Targeted Link CSV Upload"
                        targetsEdited={targetsEdited}
                        setTargetsEdited={setTargetsEdited}
                        isEditing={isEditing}
                        setFormEdited={setFormEdited}
                        description="Please upload a CSV containing the Targeted Links that you would like to migrate"
                        templateFileName="Link_Template.csv"
                        expectedColumns={LinkMigrationExpectedColumns}
                        setCSVInvalid={setCSVInvalid}
                      />
                    </Grid>
                  </Grid>
                </div>
                {cancelAlertDialog()}
              </PageContainer>
            </>
          )}
      </Fragment>
    </Box>
  );
};

const hoc = withRouter(LinkMigrationPage);

// EXPORT COMPONENT
export { hoc as LinkMigrationPage };
